export default __webpack_public_path__ + "static/media/STRIP-Logo1.50a01b3e.png";